import { getAllBrands } from 'aster-foundation/core/epharmacy/Category/redux/action';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dataLayerSendEvent, getViewItemListBrand } from 'Epharmacy/EpharmacyAnalytics';
import { PRODUCT_CARD_DEFAULT } from '../../Assets/images';
import { ONE_ASTER_CATEGORY_HOME, ONLINE_PHARMACY_ROUTE } from '@common/Utility/constants';
import WithLoader from '../Loader/WithLoader';
import { ShopByBrandsStyled } from './ShopByBrandsStyled';
import SectionBox from '../SectionBox/SectionBox';
import SlickSlider from '../SlickSlider/SlickSlider';
import Image from 'next/image';
import { errorHandlingEpharmacy, getReferralPageForGA, getImageUrlWithSize } from '@common/Utility/common-utils';
import { sendEventToSmartLook } from '@common/Utility/smartlook';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { useTranslation } from '@common/i18n';

const responsive = [
  {
    breakpoint: 980,
    settings: {
      slidesToShow: 6,
    },
  },
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 4,
    },
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 2,
      variableWidth: true,
    },
  },
];

const BrandItem = (props) => {
  const router = useRouter();
  const generateURL = useNavigationURL();
  const pageType = getReferralPageForGA(router?.asPath);
  const brandLink = `${ONLINE_PHARMACY_ROUTE}/${props?.brandUrl}`;
    const deeplink=props?.webNavigationURL;
  
  return (
    
    <a
      href={generateURL(deeplink || brandLink)}
      className="brandItemBox"
      onClick={(e) => {
        e.preventDefault();
        dataLayerSendEvent('brand_item_clicked', {
          brand_name: props?.name,
          position: props?.index+1,
          brand_id: String(props?.brandId),
          screen_name: router?.query?.slugname
          ? router?.query?.slugname
          : props?.pageName === ONE_ASTER_CATEGORY_HOME?.PHARMACY
          ? 'epharmacy homepage'
          : props?.pageName === ONE_ASTER_CATEGORY_HOME?.CORE
          ? 'asco homepage'
          : props?.pageName === ONE_ASTER_CATEGORY_HOME?.DOCTOR
          ? 'doctor consult homepage'
          : props?.pageName,
          section_name: props?.title,   
          page_type: props?.pageType,
          myaster_category: 'epharmacy',
        });
        router.push({
          pathname: generateURL(deeplink || brandLink),
        });
      }}
    >
      <div className="item">
        <Image
          data-test="div_2"
          src={getImageUrlWithSize(props?.BrandImage, 120, 60) || PRODUCT_CARD_DEFAULT.src}
          alt={props?.title}
          width="120px"
          height="60px"
          unoptimized
        />
      </div>
    </a>
  );
};

const ShopByBrands = (props) => {
  const ShopByBrandsLoading = useSelector((state) => state?.epharmacy?.getPharmacyShopByBrand.isFetching);
  const ShopByBrandsDynamicLoading = useSelector((state) => state?.epharmacy?.getShopByBrandsJson.isFetching);
  const guestLogin = useSelector((state) => state?.astercore?.guestAccessToken?.data);
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry?.[0]?.resource);
  const [shopByBrand, setShopByBrand] = React.useState([]);
  const dispatch = useDispatch();
  const router = useRouter();
  const t = useTranslation();
  const generateURL = useNavigationURL();
  const pageType = getReferralPageForGA(router?.asPath);
  const screenName = router?.pathname;

  useEffect(() => {
    props.setLoading(ShopByBrandsLoading || ShopByBrandsDynamicLoading);
  }, [ShopByBrandsLoading, ShopByBrandsDynamicLoading]);

  useEffect(() => {
    if (userLogin || guestLogin) {
      const params = {
        pageSize: 10,
        pageFrom:0,
        key:'promoted',
        value:true,
      };
  
      dispatch(
        getAllBrands({
          params: params,
          onSuccess: (response) => {
            setShopByBrand(response?.data);
          },
          onFailure: (err) => {
            errorHandlingEpharmacy(err, true, screenName, pageType);
          },
        }),
      );
    }
  }, [props?.isReload]);

  const hasRenderedOnce = useRef(false);

   useEffect(() => {
     if (shopByBrand?.length > 0  && props?.title) {
       dataLayerSendEvent('view_item_list', {
         screen_name:
           props?.pageName === ONE_ASTER_CATEGORY_HOME?.PHARMACY
             ? 'epharmacy homepage'
             : props?.pageName === ONE_ASTER_CATEGORY_HOME?.CORE
             ? 'asco homepage'
             : props?.pageName === ONE_ASTER_CATEGORY_HOME?.DOCTOR
             ? 'doctor consult homepage'
             : props?.pageName,
         page_type: props?.pageType,
         referrer_page: props?.referrerPage,
         myaster_category: 'epharmacy',
         list_type: 'Brands',
         section_name: props?.title,
         ecommerce: {
           items: shopByBrand?.map((item, index) => {
             return { ...getViewItemListBrand(item), position: index + 1 };
           }),
         },
       });
       sendEventToSmartLook('view_item_list');
       hasRenderedOnce.current = true;
     }
   }, [props?.title]);

   const viewAllLinkClickEvent = () => {
    dataLayerSendEvent('view_all_link_click', {
      screen_name:
        props?.pageName === ONE_ASTER_CATEGORY_HOME?.PHARMACY
          ? 'epharmacy homepage'
          : props?.pageName === ONE_ASTER_CATEGORY_HOME?.CORE
          ? 'asco homepage'
          : props?.pageName === ONE_ASTER_CATEGORY_HOME?.DOCTOR
          ? 'doctor consult homepage'
          : props?.pageName, 
      page_type: props?.pageType,
      page_id: null,
      myaster_category: 'epharmacy',
      section_name: props?.title,
      type: 'brand carousel',
    });
    sendEventToSmartLook('view_all_link_click');
  };
  return (
    <>
      {shopByBrand && shopByBrand?.length > 0 ? (
        <ShopByBrandsStyled title={props?.title} viewAll={props?.viewAll}>
          <SectionBox
            title={props?.title}
            customClass="sectionBox ePharmacy"
            customOuterClass="pb-0 whiteBg"
            bgColor={props?.bgColor}
            rightTop={
              shopByBrand?.length > 6 && props?.viewAll &&(
                <a
                  className="link me-2"
                  role="button"
                  aria-pressed="false"
                  tabIndex="0"
                  data-test="shopby"
                  href={generateURL(`${ONLINE_PHARMACY_ROUTE}/brandlisting`)}
                  onClick={(e) => {
                    e.preventDefault();
                    viewAllLinkClickEvent();
                    if (props?.viewAll && props?.linkWebViewAll!="" && props?.linkWebViewAll!=null) {
                      router.push({
                        pathname:generateURL(`${ONLINE_PHARMACY_ROUTE}/${props?.linkWebViewAll}`)
                      });
                    }
                  }}
                >
                  {t('EPharmacyHome.viewAll')}
                </a>
              )
            }
          >
            {shopByBrand && (
              <SlickSlider
                sliderSettings={{
                  responsive: responsive,
                  slidesToShow: 6,
                  infinite: false,
                  className: '',
                  dots: false,
                }}
              >
                {shopByBrand?.map((item, id) => {
                  return (
                    <BrandItem
                      key={id}
                      index={id}
                      BrandImage={item?.image}
                      name={item?.title}
                      brandId={item?.id}
                      webNavigationURL={item?.webNavigationURL}
                      brandUrl={item?.brandUrl}
                      pageName={props?.pageName}
                      pageType={props?.pageType}
                      title={props?.title}
                    />

                  );
                })}
              </SlickSlider>
            )}
          </SectionBox>
        </ShopByBrandsStyled>
      ) : (
        ''
      )}
    </>
  );
};

BrandItem.propTypes = {
  BrandImage: PropTypes.string,
  name: PropTypes.string,
  index: PropTypes.number,
  brandId: PropTypes.string,
  webNavigationURL:PropTypes.string,
};

BrandItem.defaultProps = {
  BrandImage: '',
};

ShopByBrands.propTypes = {
  shopByBrandsApi: PropTypes.string,
  setLoading: PropTypes.any,
  isReload: PropTypes.bool,
  data: PropTypes.any,
  title: PropTypes.string,
};

export default WithLoader(ShopByBrands);
